import List from './List.vue';

export default List;


// WEBPACK FOOTER //
// ./src/pages/event/list/index.js